import React, { useContext } from 'react';

import { singularOrPlural } from 'utils';

import { bestOfCategoryAward } from '../../ResourceCard/bestOfAwardLabel';
import { ResourceDetailContext } from '../ResourceDetailContext';
import {
  ResourceDetailBestOfAwardContainer,
  ResourceDetailBestOfAwardIcon,
  ResourceDetailBestOfAwardIconContainer,
  ResourceDetailBestOfAwardText,
  ResourceDetailBestOfAwardWrapper,
} from './styled';

export default function ResourceDetailBestOfAward() {
  const { data } = useContext(ResourceDetailContext);
  const award = data?.best_of_year;
  const category = award?.category || data?.resource_submission_category;
  const votingCompaniesCount = data?.voting_companies?.length;
  const isV2Award = Boolean(award?.category);
  const placementLabel = award?.status === 'winner' ? 'Winner' : 'Honoree';

  if (award?.category_award !== undefined) {
    const categoryAward = bestOfCategoryAward(award);
    const recognitions = [
      ...(categoryAward
        ? [
            {
              label: `Category ${
                categoryAward.status === 'winner' ? 'winner' : 'honoree'
              } of Best of ${award.year}: ${categoryAward.category?.name}`,
              icon: categoryAward.category?.icon,
            },
          ]
        : []),
      ...(award.jury_prizes || []).map((prize) => ({
        label: `Jury prize winner of Best of ${award.year}: ${prize.name}`,
        icon: prize.icon,
      })),
    ];
    return (
      <ResourceDetailBestOfAwardWrapper
        style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 12, padding: 20 }}
      >
        {recognitions.map((recognition) => (
          <ResourceDetailBestOfAwardContainer key={recognition.label}>
            {recognition.icon ? (
              <ResourceDetailBestOfAwardIconContainer>
                <ResourceDetailBestOfAwardIcon src={recognition.icon} />
              </ResourceDetailBestOfAwardIconContainer>
            ) : null}
            <ResourceDetailBestOfAwardText>{recognition.label}</ResourceDetailBestOfAwardText>
          </ResourceDetailBestOfAwardContainer>
        ))}
      </ResourceDetailBestOfAwardWrapper>
    );
  }

  return (
    <ResourceDetailBestOfAwardWrapper>
      <ResourceDetailBestOfAwardContainer>
        <ResourceDetailBestOfAwardIconContainer>
          <ResourceDetailBestOfAwardIcon src={category?.icon || category?.icon_url} />
        </ResourceDetailBestOfAwardIconContainer>
        <ResourceDetailBestOfAwardText>
          {isV2Award ? (
            <>
              {placementLabel} of Best of {award?.year}: {category?.name}
            </>
          ) : (
            <>
              Most Voted in Best of {award?.year}: {category?.name} by {votingCompaniesCount}{' '}
              {singularOrPlural(votingCompaniesCount, 'company', 'companies')}
            </>
          )}
        </ResourceDetailBestOfAwardText>
      </ResourceDetailBestOfAwardContainer>
    </ResourceDetailBestOfAwardWrapper>
  );
}
